module.exports = __webpack_public_path__ + "61df3318d77078d9fe2d9dee5e4f08f4.png";